export const createClusterWorker = (): Worker =>
  new Worker(new URL('./clusterAssets.worker.ts', import.meta.url), { type: 'module' });
